import { render, staticRenderFns } from "./parkbottom.vue?vue&type=template&id=a36a4dcc&scoped=true&"
import script from "./parkbottom.vue?vue&type=script&lang=js&"
export * from "./parkbottom.vue?vue&type=script&lang=js&"
import style0 from "./parkbottom.vue?vue&type=style&index=0&id=a36a4dcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36a4dcc",
  null
  
)

export default component.exports